import { connect } from 'react-redux';
import { GET_SITEMAP_PENDING } from '../../actions';
import Root from './Root';

const mapStateToProps = state => ({
  loading: state.sitemap.loading,
  tree: state.sitemap.tree,
});

const mapDispatchToProps = dispatch => ({
  getSitemap: () => dispatch({
    type: GET_SITEMAP_PENDING,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);
